import { render } from "./PopupBanTheHienLenh.vue?vue&type=template&id=424c17b3"
import script from "./PopupBanTheHienLenh.vue?vue&type=script&lang=js"
export * from "./PopupBanTheHienLenh.vue?vue&type=script&lang=js"

import exportComponent from "E:\\SonPhat\\Project\\fe_smartphone-doi-soat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__